// import Carousel from 'bootstrap/js/dist/carousel';

// console.log('carousel script');
